export default class FactureAvoirPartielRefactController {

    static $inject = [
        '$scope',
        '$state',
        '$stateParams',
        'AvoirsService',
        'notification',
        'ModalService',
        '$uibModal',
        'moment',
        '$translate'
    ];

    constructor($scope, $state, $stateParams, AvoirsService, notification, ModalService, $uibModal, moment, $translate) {
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.AvoirsService = AvoirsService;
        this.notification = notification;
        this.ModalService = ModalService;
        this.$uibModal = $uibModal;
        this.moment = moment;
        this.$translate = $translate;
    }

    async $onInit() {
        try {
            this.startLoading();
            this.step = 1;
            const ttcAvoir = this.avoirResult.ttcAvoir.replace(/\s+/g, '');
            const nTtcAvoir = Number(ttcAvoir.replace(',', '.'));
            console.log(nTtcAvoir);
            this.isAvoirAvailable = nTtcAvoir >= 0 ? false : true;
            this.uniquementAvoir = this.$translate.instant('FACTURES.AVOIR.UNIQUEMENT_AVOIR', { ttc: ttcAvoir });
        } catch (ex) {
            this.notification.error(ex.data);
        } finally {
            this.stopLoading();
        }
    }

    avoir() {
        this.avoirResult.type = 1;
        this.step = 2;
        let nbDelete = this.avoirResult.ticketRefacts.filter((element) => element.isDelete).length;
        if (nbDelete == 0) {
           this.createAvoirRefact(true); 
        }
    }

    refacture() {
        this.avoirResult.type = 2;
        this.step = 2;
        let nbDelete = this.avoirResult.ticketRefacts.filter((element) => element.isDelete).length;
        if (nbDelete == 0) {
           this.createAvoirRefact(true); 
        }
    }

    async createAvoirRefact(isCancel) {
        try {
            this.startLoading();
            if (isCancel) {
                for (let i = 0; i < this.avoirResult.ticketRefacts.length; i++) {
                    const element = this.avoirResult.ticketRefacts[i];
                    if (element.isDelete) {
                        element.deleteOption.isCancel = 1;
                    }
                } 
                this.avoirResult.dateValorisation = this.date;
                const recap = await this.AvoirsService.createAvoir(this.avoirResult); 
                this.modalInstance.close();  
                this.$uibModal.open({
                    template:
                        '<facture-avoir-recap recap="$ctrl.recap" modal-instance="$ctrl.uibModalInstance"></facture-avoir-recap>',
                    controller: [
                        '$uibModalInstance',
                        function ($uibModalInstance) {
                            var $ctrl = this;
                            $ctrl.recap = recap;
                            $ctrl.uibModalInstance = $uibModalInstance;
                        },
                    ],
                    controllerAs: '$ctrl',
                    size: 'l',
                    backdrop: false
                }); 
            }
            else {
                this.modalInstance.close();
                var _this = this;
                this.$uibModal.open({
                    template:
                        '<facture-avoir-select avoir-data="$ctrl.avoirData" date="$ctrl.date" modal-instance="$ctrl.uibModalInstance"></facture-avoir-select>',
                    controller: [
                        '$uibModalInstance',
                        function ($uibModalInstance) {
                            var $ctrl = this;
                            $ctrl.avoirData = _this.avoirResult;
                            $ctrl.date = _this.date;
                            $ctrl.uibModalInstance = $uibModalInstance;
                        },
                    ],
                    controllerAs: '$ctrl',
                    size: 'xl',
                    backdrop: false
                });
            }
        } catch (ex) {
            this.notification.error(ex.data);
        } finally {
            this.stopLoading();
        }
    }

    async annuler() {
        this.modalInstance.close();
        if (this.avoirResult) {
            await this.AvoirsService.deleteTicketFictifs(this.avoirResult.idTickets);
        }
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }
}
